import React from 'react';
import useTheme from '../../hooks/ui/useTheme';

interface Props {
  className?: string;
  style?: object;
  color?: string;
}

export default function ErrorIllustration(props: Props) {
  const { className, color, style } = props;

  const theme = useTheme();

  return (
    <svg className={className ?? 'lg:w-1/4 md:w-1/2 w-3/4 mx-auto'} viewBox="0 0 900 600" fill="none" style={style}>
      <path fill="transparent" d="M0 0h900v600H0z" />
      <path
        d="M795.702 388.602h-62.837c-15.397 0-28.297-10.479-28.297-23.753 0-6.637 3.329-12.575 8.323-16.767 4.994-4.191 12.068-6.986 19.974-6.986h9.155c7.907 0 14.981-2.794 19.975-6.986 4.994-4.192 8.323-10.13 8.323-16.767 0-12.924-12.484-23.753-28.298-23.753H550.096c-5.014 0-8.237-6.163-8.237-11.177 0-12.575-12.068-22.705-27.048-22.705h-71.422a6.812 6.812 0 0 1 0-13.623h273.663c12.068 0 23.304-4.192 31.21-10.829 7.907-6.637 12.901-16.068 12.901-26.198 0-20.609-19.975-37.026-44.111-37.026H575.709c-22.178 0-44.13-17.116-66.308-17.116h-78.914c-11.575 0-20.959-9.384-20.959-20.959s9.384-20.958 20.959-20.958h176.706c8.322 0 16.229-2.795 21.639-7.336 5.409-4.541 8.738-10.828 8.738-18.164C637.57 73.527 623.838 62 607.193 62H199.796c-8.322 0-16.229 2.794-21.639 7.335s-8.739 10.829-8.739 18.164c0 13.973 13.733 25.5 30.378 25.5H210.2c13.732 0 25.384 9.431 25.384 21.308 0 5.938-2.913 11.177-7.491 15.02-4.577 3.842-10.819 6.287-17.893 6.287h-50.353c-8.739 0-17.061 3.144-22.887 8.034-5.826 4.891-9.571 11.527-9.571 19.212 0 15.02 14.564 26.897 32.042 26.897h51.185c16.645 0 30.378 11.527 30.378 25.499 0 6.986-3.329 13.274-8.739 17.815-5.41 4.541-12.9 7.335-21.223 7.335h-45.775c-7.49 0-14.149 2.445-19.142 6.637-4.994 4.192-7.907 9.781-7.907 16.068 0 12.575 12.068 22.705 27.049 22.705h37.036c21.223 0 38.284 14.322 38.284 32.136 0 8.733-4.161 17.116-11.235 22.705-7.074 5.939-16.646 9.432-27.049 9.432h-51.601c-10.403 0-19.974 3.493-26.632 9.431-7.075 5.589-11.236 13.623-11.236 22.356 0 17.465 17.062 31.787 37.868 31.787h159.334c17.597 0 34.883 9.78 52.479 9.78h29.019c11.093 0 20.085 8.993 20.085 20.085 0 11.093-8.992 20.085-20.085 20.085h-70.632c-9.155 0-17.062 3.144-22.888 8.034-5.826 4.891-9.571 11.877-9.571 19.212 0 15.021 14.565 27.246 32.459 27.246h432.78c9.155 0 17.062-3.144 22.888-8.034 5.826-4.89 9.571-11.876 9.571-19.212 0-15.02-14.565-27.246-32.459-27.246h-12.9c-13.316 0-23.72-9.082-23.72-19.91 0-5.589 2.497-10.479 7.075-13.972 4.161-3.493 10.403-5.939 17.061-5.939h54.514c9.155 0 17.061-3.143 22.887-8.034 5.826-4.89 9.571-11.876 9.571-19.212 0-15.718-14.564-27.944-32.458-27.944z"
        fill="url(#a)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M285.862 279.363v-98.666c0-20.247 13.158-38.144 32.483-44.183l138.868-43.397a46.289 46.289 0 0 1 27.614 0l138.869 43.397c19.325 6.039 32.482 23.936 32.482 44.183v98.666c0 96.478-59.846 182.836-150.181 216.711l-26.85 10.068a23.142 23.142 0 0 1-16.253 0l-26.851-10.068c-90.335-33.875-150.181-120.233-150.181-216.711z"
        fill={color ?? theme.color.danger}
      />
      <path
        d="M471.022 206.126v93.186"
        stroke="#fff"
        strokeWidth="34.703"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M471.021 368.748a2.894 2.894 0 0 1 2.893 2.893"
        stroke="#fff"
        strokeWidth="41.748"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89.809 318.049c16.815-8.342 39.134 2.384 39.134 2.384s-4.96 24.245-21.785 32.575c-16.816 8.342-39.125-2.372-39.125-2.372s4.96-24.246 21.776-32.587z"
        fill="url(#b)"
      />
      <path
        d="M813.849 251.536c-15.569-9.331-37.906-.705-37.906-.705s2.921 23.751 18.499 33.072c15.57 9.331 37.897.716 37.897.716s-2.921-23.752-18.49-33.083z"
        fill="url(#c)"
      />
      <circle r="9.533" transform="matrix(1 0 0 -1 278.198 94.81)" fill="#E1E4E5" />
      <circle r="13.77" transform="matrix(1 0 0 -1 686.005 132.297)" fill="#E1E4E5" />
      <circle r="10.48" transform="matrix(1 0 0 -1 99.143 141.618)" fill="#E1E4E5" />
      <circle r="10.463" transform="matrix(0 -1 -1 0 792.763 470.649)" fill="#E1E4E5" />
      <circle r="13.919" transform="matrix(1 0 0 -1 618.51 507.354)" fill="#E1E4E5" />
      <ellipse rx="10.707" ry="8.566" transform="matrix(1 0 0 -1 201.409 234.864)" fill="#E1E4E5" />
      <circle r="13.345" transform="scale(-1 1) rotate(-75 172.299 410.654)" fill="#E1E4E5" />
      <path
        d="M777.546 169.359h-.146c-.868-12.759-10.005-12.955-10.005-12.955s10.076-.204 10.076-14.947c0 14.743 10.076 14.947 10.076 14.947s-9.134.196-10.001 12.955z"
        fill="#E1E4E5"
      />
      <defs>
        <linearGradient id="a" x1="485.745" y1="805.037" x2="475.973" y2="-456.017" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#EEE" />
        </linearGradient>
        <linearGradient id="b" x1="154.383" y1="292.03" x2="15.686" y2="401.739" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#EEE" />
        </linearGradient>
        <linearGradient id="c" x1="753.601" y1="221.499" x2="878.876" y2="337.897" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#EEE" />
        </linearGradient>
      </defs>
    </svg>
  );
}
